import axios from "axios"
import store from "@store/index.js"
import { os } from "@commons/util.js"
function customConfirm(){
    var r = confirm("登录信息已变动，将重新刷新页面!");
    window.location.reload()
}
let instance = axios.create()
instance.defaults.withCredentials = true
instance.interceptors.request.use(function (config) {
    let userWsid = store.state.loginLocalStatus.userWsid
    if(os.isPc&&userWsid&&localStorage.getItem('wesign-login-status').indexOf(userWsid)<0){
        customConfirm()
    }
    // 兼容IE下会自动缓存GET问题
    if (/^get$/i.test(config.method)){
        if (!config.params) config.params = {}
        config.params.flag = Date.now()
    }
    // 修改DELETE,PUT为POST
    if(!/^(get|post)$/i.test(config.method)){
        if (!config.params) config.params = {}
        config.params.httpmethod = config.method //原始请求方式放在query
        config.method = "post" //修改为post请求方式
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

export default instance